import type { XYChartBarSeriesProps } from '../types/xy-chart-props.js';

/**
 * Bar series slot component.
 * @public
 */
export const BarSeries = (props: XYChartBarSeriesProps) => null;

BarSeries['displayName'] = 'XYChart.BarSeries';
